import { DateTime } from '@ksyos/date-time';
import { connect } from 'react-redux';
import type { IReduxState } from '../../../../../../configureStore';
import { UrlBuilder } from '../../../../../../../common/utils/urlBuilder';
import { fetchJson } from '../../../../../../store/fetch';
import { translateKey } from '../../../../../../translate';
import { Component } from '../../../../../elements/Component';
import { NOABNORMALITY, NODIAGNOSISYET } from './Icd10Selection';

interface IDisplayIcd10Props {
    icd10Code: string | null;
    onContentLoaded?: (hasContent: boolean) => Promise<void>;
    thesaurusTermDate?: string | null;
    thesaurusTermId?: string | null;
}

interface IDisplayIcd10ReduxProps {
    languageCode: string;
}

interface IDisplayIcd10State {
    icd10CodeText?: { [key: string]: string };
    thesaurusTermDescription?: string;
}

const mapStateToProps = ({ language: { code: languageCode } }: IReduxState): IDisplayIcd10ReduxProps => ({
    languageCode,
});

export class DisplayIcd10Wrapper extends Component<IDisplayIcd10Props & IDisplayIcd10ReduxProps, IDisplayIcd10State> {
    public async componentDidMount() {
        if (this.props.thesaurusTermId) {
            const urlBuilder = new UrlBuilder('/api/dhdThesaurus/thesaurusTerms');
            urlBuilder.add('termId', this.props.thesaurusTermId);
            if (this.props.thesaurusTermDate) {
                urlBuilder.add('date', DateTime.from(this.props.thesaurusTermDate).format('YYYY-MM-DD'));
            }
            const result = await fetchJson(urlBuilder.build(), 'GET');
            if (result.json && result.json.items && result.json.items.length > 0) {
                await this.setState({ thesaurusTermDescription: result.json.items[0].description });
            }
        }
        if (
            this.props.icd10Code &&
            this.props.icd10Code !== '-' &&
            this.props.icd10Code !== NODIAGNOSISYET &&
            this.props.icd10Code !== NOABNORMALITY
        ) {
            try {
                const result = await fetchJson(
                    `/api/dhdThesaurus/icd10Codes/${encodeURIComponent(this.props.icd10Code)}`,
                    'GET'
                );
                await this.setState({
                    icd10CodeText: { en: result.json.descriptionEN, nl: result.json.descriptionNL },
                });
            } catch (e) {
                // Empty block
            }
        }

        if (this.props.onContentLoaded) {
            await this.props.onContentLoaded(
                this.props.icd10Code !== undefined &&
                    (this.props.icd10Code === '-' ||
                        this.props.icd10Code === NODIAGNOSISYET ||
                        this.props.icd10Code === NOABNORMALITY ||
                        this.state.icd10CodeText !== undefined)
            );
        }
    }

    public render() {
        let text = '';
        if (this.state.thesaurusTermDescription) {
            text = this.state.thesaurusTermDescription;
        } else if (!this.props.icd10Code) {
            return null;
        } else if (this.props.icd10Code === '-') {
            text = translateKey('diagnosis.unableToDiagnose');
        } else if (this.props.icd10Code === NODIAGNOSISYET) {
            text = translateKey('diagnosis.noDiagnosisYet');
        } else if (this.props.icd10Code === NOABNORMALITY) {
            text = translateKey('diagnosis.noAbnormality');
        } else if (this.state.icd10CodeText) {
            text = this.state.icd10CodeText[this.props.languageCode];
        }

        return <span>{text}</span>;
    }
}

export const DisplayIcd10 = connect(mapStateToProps)(DisplayIcd10Wrapper);
